import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import JudgeRoute from './components/JudgeRoute';

// Import pages
import Home from './pages/Home';
import Apply from './pages/Apply';
import Team from './pages/Team';
import Submission from './pages/Submission';
import SubmissionRequirements from './pages/SubmissionRequirements';
import Login from './pages/Login';
import Certificate from './pages/Certificate';
import NotFound from './pages/NotFound';

// Import admin components
import Dashboard from './admin/Dashboard';
import Applicants from './admin/Applicants';
import Teams from './admin/Teams';
import Projects from './admin/Projects';
import Stats from './admin/Stats';
import DiscardedForms from './admin/DiscardedForms';
import Feedback from './admin/Feedback';
import Notifications from './admin/Notifications';

// Import judge components
import JudgeProjects from './judge/JudgeProjects';
import JudgeTeams from './judge/JudgeTeams';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/apply" element={<Apply />} />
            <Route path="/team" element={<Team />} />
            <Route path="/submission" element={<Submission />} />
            <Route path="/submission-requirements" element={<SubmissionRequirements />} />
            <Route path="/login" element={<Login />} />
            <Route path="/certificate" element={<Certificate />} />

            {/* Redirects */}
            <Route path="/discord" Component={() => {
    window.location.href = "https://discord.gg/jpRGNsyfcw";
    return null;
  }} />
            <Route path="/verify" Component={() => {
    window.location.href = "https://qimmabot.vercel.app/api/login";
    return null;
  }} />
            <Route path="/nsave" Component={() => {
    window.location.href = "https://web.nsave.com/referral/egyptianfreelancers";
    return null;
  }} />
            {/* Protected Admin Routes */}
            <Route path="/admin" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/admin/applicants" element={
              <ProtectedRoute>
                <Applicants />
              </ProtectedRoute>
            } />
            <Route path="/admin/teams" element={
              <ProtectedRoute>
                <Teams />
              </ProtectedRoute>
            } />
            <Route path="/admin/projects" element={
              <ProtectedRoute>
                <Projects />
              </ProtectedRoute>
            } />
            <Route path="/admin/stats" element={
              <ProtectedRoute>
                <Stats />
              </ProtectedRoute>
            } />
            <Route path="/admin/discarded" element={
              <ProtectedRoute>
                <DiscardedForms />
              </ProtectedRoute>
            } />
            <Route path="/admin/feedback" element={
              <ProtectedRoute>
                <Feedback />
              </ProtectedRoute>
            } />
            <Route path="/admin/notifications" element={
              <ProtectedRoute>
                <Notifications />
              </ProtectedRoute>
            } />

            {/* Protected Judge Routes */}
            <Route path="/judge" element={
              <JudgeRoute>
                <JudgeProjects />
              </JudgeRoute>
            } />
            <Route path="/judge/projects" element={
              <JudgeRoute>
                <JudgeProjects />
              </JudgeRoute>
            } />
            <Route path="/judge/teams" element={
              <JudgeRoute>
                <JudgeTeams />
              </JudgeRoute>
            } />

            {/* not found */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
